import React from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function UserAdd() {
    const navigate = useNavigate();

    const [formValue, setformValue] = React.useState({
        username: "",
        email: "",
        password: "",
    });

    const handleChange = (event) => {
        setformValue({
            ...formValue,
            [event.target.name]: event.target.value,
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        // store the states in the form data
        const FormDataInput = new FormData();

        FormDataInput.append("username", formValue.username);
        FormDataInput.append("email", formValue.email);
        FormDataInput.append("password", formValue.password);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // make axios post request
            const response = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/users/createUser`,
                data: FormDataInput,
                headers: { "Content-Type": "application/json" },
            });
            Swal.fire({
                title: "Success",
                text: "Data berhasil ditambah",
                icon: "success",
            });
            navigate("/user");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal ditambah",
                icon: "error",
            });
        }
    };
    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">User</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah User</h3>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Username</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="username"
                                                        placeholder="Masukkan username"
                                                        onChange={handleChange}
                                                        value={formValue.username}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        placeholder="Masukkan email"
                                                        onChange={handleChange}
                                                        value={formValue.email}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Password</label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        name="password"
                                                        placeholder="Masukkan password"
                                                        onChange={handleChange}
                                                        value={formValue.password}
                                                    />
                                                </div>

                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/user">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                            {/* /.card-body */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default UserAdd;
